import featureToggles from 'shared/featureToggles'
import {
    CUSTOMER_TYPE_BUSINESS,
    CUSTOMER_TYPE_CO_BUSINESS,
    CUSTOMER_TYPE_CO_CITIZEN,
    CUSTOMER_TYPE_CO_FOREIGNER,
    CUSTOMER_TYPE_INDIVIDUAL,
} from 'shared/constants'

export const BR_DOCUMENT_TYPES = [
    {
        label: 'CPF',
        value: CUSTOMER_TYPE_INDIVIDUAL,
    },
    {
        label: 'CNPJ',
        value: CUSTOMER_TYPE_BUSINESS,
    },
]

export const CO_DOCUMENT_TYPES = [
    {
        label: 'document.type.co.citizen',
        value: CUSTOMER_TYPE_CO_CITIZEN,
    },
    {
        label: 'document.type.co.foreigner',
        value: CUSTOMER_TYPE_CO_FOREIGNER,
    },
]

export const DOCUMENT_TYPES = featureToggles.isColumbia ? CO_DOCUMENT_TYPES : BR_DOCUMENT_TYPES

export const DOCUMENT_TYPE_NUMBER_PATTERN = {
    [CUSTOMER_TYPE_INDIVIDUAL]: /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/,
    [CUSTOMER_TYPE_BUSINESS]: /^\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}$/,
    [CUSTOMER_TYPE_CO_CITIZEN]: /^\d$/,
    [CUSTOMER_TYPE_CO_FOREIGNER]: /^\d$/,
    [CUSTOMER_TYPE_CO_BUSINESS]: /^\d{9}$/,
}

export const DOCUMENT_TYPE_MASK = {
    [CUSTOMER_TYPE_INDIVIDUAL]: 'XXX.XXX.XXX-XX',
    [CUSTOMER_TYPE_BUSINESS]: 'XX.XXX.XXX/XXXX-XX',
    [CUSTOMER_TYPE_CO_CITIZEN]: 'XXXXXX',
    [CUSTOMER_TYPE_CO_FOREIGNER]: 'XXXXXX',
    [CUSTOMER_TYPE_CO_BUSINESS]: 'XXXXXXXXX',
}

export const DOCUMENT_TYPE_NUMBER_VALIDATION = {
    [CUSTOMER_TYPE_INDIVIDUAL]: 'isValidCPF',
    [CUSTOMER_TYPE_BUSINESS]: 'isValidCNPJ',
    [CUSTOMER_TYPE_CO_BUSINESS]: 'isValidNIT',
}

export const DOCUMENT_TYPE_NUMBER_LENGTH_VALIDATION = {
    [CUSTOMER_TYPE_INDIVIDUAL]: 'isValidCPFLength',
    [CUSTOMER_TYPE_BUSINESS]: 'isValidCNPJLength',
    [CUSTOMER_TYPE_CO_CITIZEN]: 'isValidCoIndividual',
    [CUSTOMER_TYPE_CO_FOREIGNER]: 'isValidCoIndividual',
    [CUSTOMER_TYPE_CO_BUSINESS]: 'isValidNITLength',
}
